import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { createRoot } from 'react-dom/client'
import UppyProxyPreactToReact from './UppyProxyPreactToReact.js'
import { useUppy, useUppyPlugin } from 'design-system/FileUploader/react.js'
import PaperClipIcon from 'design-system/Svgs/PaperClipIcon/view.js'
import GraphIcon from 'design-system/Svgs/GraphIcon/view.js'
import DocIcon from 'design-system/Svgs/DocIcon/view.js'

export default function FileUploaderPluginUI(props) {
  let [contentEl, setContentEl] = useState(
    /** @type {HTMLElement | null} */ (null)
  )

  let uppy = useUppy(props)
  let uppyPlugin = useUppyPlugin(props)

  useEffect(() => {
    let plugin = uppy.getPlugin(props.name)
    if (plugin) {
      uppy.removePlugin(plugin)
    }

    uppy.use(UppyProxyPreactToReact, {
      id: props.name,
      title: props.name,
      renderIcon: (/** @type {HTMLElement | null} */ el) => {
        if (!el) return
        let root = createRoot(el)
        root.render(<Icon name={props.name} />)
      },
      renderContent: (/** @type {HTMLElement | null} */ el) => {
        setContentEl(el)

        if (el) {
          props.onMount && props.onMount()
        } else {
          props.onUnmount && props.onUnmount()
        }
      },
    })

    return uppyPlugin(props.name)
  }, [uppy]) // eslint-disable-line
  // ignore uppyPlugin

  return contentEl
    ? createPortal(
        typeof props.children === 'function'
          ? props.children()
          : props.children,
        contentEl
      )
    : null
}

/**
 * @param {{ name: string }} props
 */
function Icon({ name }) {
  switch (name) {
    case 'Documents':
      return <PaperClipIcon />
    case 'Images':
      return <GraphIcon />
    default:
      return <DocIcon />
  }
}
